import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-delete-white",
  "use": "icon-delete-white-usage",
  "viewBox": "0 0 10.6 10.6",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 10.6 10.6\" id=\"icon-delete-white\">\n<polygon style=\"fill:currentColor;\" points=\"10.6,1.4 9.2,0 5.3,3.9 1.4,0 0,1.4 3.9,5.3 0,9.2 1.4,10.6 5.3,6.7 9.2,10.6 10.6,9.2 6.7,5.3 \" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol